import { Operation } from 'fast-json-patch'

import { servicesAsync } from 'Common/environment/environment'
import { Claim } from 'Common/types'
import { fetchDelete, fetchGet, fetchPatch, fetchPost } from 'Common/utils/query/request'

const baseUrl = servicesAsync.users('/v1/users')

export type User = {
    accessFailedCount: number
    claims: Claim[]
    email: string
    firstName: string
    lastName: string
    id: string
    isLockedOut: boolean
    lockoutEnabled: boolean
    userName: string
    phoneNumber: string
}

type SimpleUser = {
    userName: string
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    phoneNumber?: string | null
}

interface UserPatch {
    id: string
    patchSet: Operation[]
}

interface PasswordRequest {
    id: string
    password: string
}

export const getUser = async (id: string) => {
    return await fetchGet(`${await baseUrl}/${id}`)
}

export const getUsers = async () => {
    return await fetchGet(`${await baseUrl}`)
}

export const patchUser = async (request: UserPatch) => {
    return await fetchPatch(`${await baseUrl}/${request.id}`, JSON.stringify(request.patchSet))
}

export const deleteUser = async (id: string) => {
    return await fetchDelete(`${await baseUrl}/${id}`)
}

export const postUser = async (user: SimpleUser) => {
    return await fetchPost(`${await baseUrl}`, JSON.stringify(user))
}

export const postUserPassword = async (request: PasswordRequest) => {
    return await fetchPost(
        `${await baseUrl}/${request.id}/password`,
        JSON.stringify({ password: request.password }),
    )
}
